/**
 * Simplify MAC address: remove separators and convert to uppercase
 * @example simplifyMacAddress('00:aa:22:33:44:55') -> '00AA22334455'
 */
export function simplifyMacAddress(mac?: string): string {
  if (!mac) {
    return '';
  }
  return mac.toUpperCase().replace(/[^A-Z0-9]/g, '');
}
